import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_custom_templates_ux');
	},
};
